export const FONT_SMALL = '.75em'